import { Modal } from "antd";
import { useState } from "react";
import { IExpense2 } from "../../../types/types";
import ExpenseEditSection from "./edit.section";
import ExpenseViewSection from "./view.section";

export default function ExpenseViewModal({
  expense,
  onClose,
}: {
  expense?: IExpense2;
  onClose: () => void;
}) {
  console.log("View expense modal", expense);
  const [editMode, setEditMode] = useState<boolean>(false);
  return (
    <Modal
      width={"min(92vw, 800px)"}
      closable={{ "aria-label": "Custom Close Button" }}
      open={!!expense}
      onCancel={onClose}
      footer={null}
    >
      {editMode && (
        <ExpenseEditSection
          expense={expense}
          onCancel={() => setEditMode(false)}
        />
      )}

      {!editMode && (
        <ExpenseViewSection
          onEdit={() => setEditMode(true)}
          groupId={expense?.groupId}
          expenseId={expense?.id}
        />
      )}
    </Modal>
  );
}
